/* eslint-disable no-underscore-dangle */
import {useQuery} from '@apollo/client';
import {GetTournamentsData} from 'packages/common-types/queries-types';
import ErrorBoundary from 'packages/common-ui/ErrorBoundary';
import {GET_TOURNAMENTS} from 'packages/graphql/v2/queries';
import useAppDispatch from 'packages/hooks/use-app-dispatch';
import useAppSelector from 'packages/hooks/use-app-selector';
import Select from 'react-select';
import Skeleton from '@material-ui/lab/Skeleton';

import {
  selectTournament,
  setSelectedTournament,
} from 'redux/features/app-slice';
import {
  setGeneratedRound,
  setLoadedRound,
  setSelectedRound,
} from 'redux/features/round-slice';

const SelectTournament = () => {
  const dispatch = useAppDispatch();
  const selectedTournament = useAppSelector(selectTournament);
  const {data, loading, error} = useQuery<GetTournamentsData>(GET_TOURNAMENTS);
  const startedTournaments = data?.getTournaments.filter(
    (tournament) => tournament.status === 'Iniciado'
  );
  const handleSelectTournament = (value: any) => {
    dispatch(setLoadedRound(null));
    dispatch(setGeneratedRound(null)); // We do this to prevent outdated data
    dispatch(setSelectedRound({label: '', value: ''}));
    dispatch(setSelectedTournament(value));
  };

  if (loading) return <Skeleton variant="text" height={50} />;
  if (error) return <ErrorBoundary error={error} />;

  return (
    <Select
      isLoading={loading}
      value={selectedTournament}
      onChange={handleSelectTournament}
      placeholder="Selecciona un torneo"
      options={startedTournaments}
      getOptionLabel={(option) =>
        `${option.name}:${option.conditions.modalityGame}`
      }
      getOptionValue={(option) => JSON.stringify(option)}
    />
  );
};

export default SelectTournament;
